/**
 * 文件说明:
 *
 * hz ContentTabs component
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, forwardRef} from 'react'
import {history} from 'umi'
import {ContentTabs} from '@huzan/hz-layout'
import classnames from 'classnames'
import styles from './index.less'

const ContentTabsWarp = memo(
    forwardRef((props, ref) => {
        const {className, ...restProps} = props

        const newClassName = classnames(styles.main, className)

        return (
            <ContentTabs
                {...restProps}
                className={newClassName}
                routerPush={history.push}
                ref={ref}
            />
        )
    }),
)

export default ContentTabsWarp
